/**
 * Localization AJAX Fix
 * Converte submits de localização para AJAX para evitar conflitos
 */
(function() {
  'use strict';
  

  
  // Cache do formulário de localização para performance
  let localizationForm = null;
  
  // Encontra o formulário assim que disponível
  function findLocalizationForm() {
    localizationForm = document.getElementById('LocalizationForm');
    if (!localizationForm) {
      // Tenta novamente em breve se não encontrar
      setTimeout(findLocalizationForm, 100);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', findLocalizationForm);
  } else {
    findLocalizationForm();
  }
  
  // Intercepta o submit do formulário
  const originalSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function() {
    if (this.id === 'LocalizationForm' || this.action?.includes('localization')) {
      handleLocalizationSubmit(this);
      return;
    }
    return originalSubmit.call(this);
  };
  
  // Intercepta eventos de submit
  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (form && (form.id === 'LocalizationForm' || form.action?.includes('localization'))) {
      event.preventDefault();
      event.stopPropagation();
      handleLocalizationSubmit(form);
    }
  }, true);
  
  // Função para lidar com o submit via AJAX
  async function handleLocalizationSubmit(form) {
    // Coleta dados do formulário
    const formData = new FormData(form);
    
    try {
      // Faz a requisição via AJAX
      const response = await fetch(form.action || '/localization', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      // Salva estado antes de recarregar
      sessionStorage.setItem('localization-ajax-reload', JSON.stringify({
        timestamp: Date.now(),
        country: formData.get('country_code'),
        locale: formData.get('locale_code')
      }));
      
      // Força recarga completa sem cache
      window.location.reload();
      
    } catch (error) {
      // Em caso de erro, tenta o método tradicional
      originalSubmit.call(form);
    }
  }
  

  
  // Verifica se página foi recarregada após mudança
  window.addEventListener('load', function() {
    const reloadData = sessionStorage.getItem('localization-ajax-reload');
    
    if (reloadData) {
      const data = JSON.parse(reloadData);
      const timeSinceReload = Date.now() - data.timestamp;
      
      if (timeSinceReload < 5000) {
        // Verifica integridade da página
        const hasCSS = document.styleSheets.length > 0;
        const hasBody = document.body && document.body.children.length > 0;
        
        if (!hasCSS || !hasBody) {
          // Tenta recarregar novamente
          setTimeout(() => {
            window.location.href = window.location.href.split('#')[0];
          }, 1000);
        }
      }
      
      sessionStorage.removeItem('localization-ajax-reload');
    }
  });
  
  // Alternativa: Intercepta cliques diretos nos países
  document.addEventListener('click', async function(event) {
    const target = event.target;
    const countryItem = target?.closest?.('.localization-form__list-item');
    
    if (countryItem && countryItem.dataset.value) {
      const form = countryItem.closest('form');
      
      if (form && (form.id === 'LocalizationForm' || form.action?.includes('localization'))) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        // Atualiza o valor e submete via AJAX
        const countryInput = form.querySelector('input[name="country_code"]');
        if (countryInput) {
          countryInput.value = countryItem.dataset.value;
          handleLocalizationSubmit(form);
        }
      }
    }
  }, true);
  
})(); 